import { useEffect, useRef, useState } from 'react'

type UseElementOverflowProps = { verticalOverflow?: boolean }

function useElementOverflow({ verticalOverflow = false }: UseElementOverflowProps = {}) {
    const [isOverflowing, setIsOverflowing] = useState(false)
    const elementRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        const element = elementRef.current
        if (!element) {
            return
        }

        const checkOverflow = () => {
            const calculatedIsOverflowing = verticalOverflow
                ? element.scrollHeight > element.clientHeight
                : element.scrollWidth > element.clientWidth

            setIsOverflowing(calculatedIsOverflowing)
        }

        checkOverflow()

        const resizeObserver = new ResizeObserver(() => {
            checkOverflow()
        })

        resizeObserver.observe(element)

        return () => {
            resizeObserver.disconnect()
        }
    }, [verticalOverflow])

    return { isOverflowing, elementRef }
}

export default useElementOverflow
